// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Super Admin Dashboard Styles */

.super-admin-dashboard-page {
    animation: fadeIn 0.5s ease;
    background: #f8fafc;
    width: 100%;
}

/* Super Admin Header */
.super-admin-welcome-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    padding: 1.5rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 16px;
    color: white;
}

.super-admin-welcome-header h1 {
    font-size: 2rem;
    font-weight: 700;
    margin: 0 0 0.5rem 0;
}

.super-admin-subtitle {
    opacity: 0.95;
    font-size: 1rem;
    margin: 0;
}

/* Super Quick Actions */
.super-quick-actions {
    display: flex;
    gap: 0.75rem;
}

.super-action-btn {
    padding: 0.75rem 1.25rem;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    border: none;
    font-size: 0.9rem;
    color: white;
}

.super-action-btn.create-admin {
    background: rgba(255, 255, 255, 0.2);
    border: 2px solid rgba(255, 255, 255, 0.3);
}

.super-action-btn.create-user {
    background: rgba(255, 255, 255, 0.15);
    border: 2px solid rgba(255, 255, 255, 0.25);
}

.super-action-btn.settings {
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.2);
}

.super-action-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
}

/* Enhanced Stats Grid */
.super-stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    grid-gap: 1.5rem;
    gap: 1.5rem;
    margin-bottom: 2rem;
}

.super-stat-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    display: flex;
    gap: 1.25rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.super-stat-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
}

.super-stat-card.purple::before {
    background: linear-gradient(135deg, #9f7aea, #805ad5);
}

.super-stat-card.pink::before {
    background: linear-gradient(135deg, #f093fb, #f5576c);
}

.super-stat-card.blue::before {
    background: linear-gradient(135deg, #4facfe, #00f2fe);
}

.super-stat-card.green::before {
    background: linear-gradient(135deg, #43e97b, #38f9d7);
}

.super-stat-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.super-stat-card.purple .stat-icon {
    background: linear-gradient(135deg, #9f7aea, #805ad5);
}

.super-stat-card.pink .stat-icon {
    background: linear-gradient(135deg, #f093fb, #f5576c);
}

.super-stat-card.blue .stat-icon {
    background: linear-gradient(135deg, #4facfe, #00f2fe);
}

.super-stat-card.green .stat-icon {
    background: linear-gradient(135deg, #43e97b, #38f9d7);
}



/* Tab Content */
.super-tab-content {
    animation: fadeIn 0.3s ease;
}

/* Super Card */
.super-card {
    background: white;
    border-radius: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.super-card-header {
    padding: 1.5rem;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.users-card-header {
    gap: 1rem;
}

.users-card-title {
    display: flex;
    flex-direction: column;
}

.users-title {
    font-size: 1rem;
    margin: 0;
    color: #2d3748;
    font-weight: 700;
}

.users-note {
    margin: 4px 0 0 0;
    color: #718096;
    font-size: 0.85rem;
}

.users-header-actions {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.include-admins-toggle {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    color: #4a5568;
}

.include-admins-toggle input[type="checkbox"] {
    width: 16px;
    height: 16px;
}

.user-status-select,
.user-kyc-select {
    padding: 6px 8px;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    background: white;
    font-size: 0.95rem;
}

.user-status-select {
    min-width: 120px;
}

.user-kyc-select {
    min-width: 140px;
}

.super-card-header h2 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1a202c;
    margin: 0;
}

.add-btn,
.export-btn {
    padding: 0.625rem 1.25rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 0.9rem;
}

.add-btn:hover,
.export-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* Header Actions */
.header-actions {
    display: flex;
    gap: 0.75rem;
    align-items: center;
}

.action-header-btn {
    padding: 0.625rem 1rem;
    border: 1px solid #e2e8f0;
    background: white;
    color: #475569;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 0.875rem;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
}

.action-header-btn:hover {
    background: #f8fafc;
    border-color: #cbd5e0;
    transform: translateY(-1px);
}

.action-header-btn.create-admin:hover {
    background: #ede9fe;
    border-color: #a78bfa;
    color: #7c3aed;
}

.action-header-btn.create-user:hover {
    background: #dbeafe;
    border-color: #60a5fa;
    color: #2563eb;
}

.action-header-btn.settings:hover {
    background: #fef3c7;
    border-color: #fbbf24;
    color: #d97706;
}

/* Overview Grid */
.overview-content {
    margin-bottom: 2rem;
}

.overview-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-gap: 1.5rem;
    gap: 1.5rem;
    padding: 1.5rem;
}

.enhanced-overview-grid {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 1rem;
    padding: 1.25rem;
}

.overview-actions {
    display: flex;
    gap: 0.5rem;
}

.insight-pulse-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    grid-gap: 1rem;
    gap: 1rem;
    padding: 0 1.25rem 0.75rem;
}

.pulse-card {
    background: linear-gradient(135deg, #0f172a, #1f2a44);
    border: 1px solid rgba(255, 255, 255, 0.06);
    color: #e2e8f0;
    border-radius: 14px;
    padding: 1rem;
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.22);
}

.pulse-label { font-size: 0.85rem; letter-spacing: 0.02em; opacity: 0.8; }
.pulse-value { font-size: 1.8rem; font-weight: 800; margin: 0.15rem 0; }
.pulse-value.warning { color: #f59e0b; }
.pulse-value.success { color: #22c55e; }
.pulse-sub { font-size: 0.85rem; color: #cbd5e1; margin-bottom: 0.35rem; }

.sparkbar {
    display: flex;
    align-items: flex-end;
    gap: 4px;
    height: 50px;
}
.sparkbar span {
    flex: 1 1;
    background: rgba(255, 255, 255, 0.14);
    border-radius: 4px 4px 0 0;
    transition: height 0.3s ease, background 0.3s ease;
}
.sparkbar.info span { background: rgba(59,130,246,0.28); }
.sparkbar.warning span { background: rgba(245,158,11,0.28); }
.sparkbar.success span { background: rgba(16,185,129,0.28); }
.sparkbar span:last-child { background: #7c3aed; }

.overview-insights {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    grid-gap: 1rem;
    gap: 1rem;
    padding: 0 1.25rem 1.25rem;
}

.insight-card {
    background: #0f172a;
    color: #e2e8f0;
    border-radius: 12px;
    padding: 1rem 1.25rem;
    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.08);
}

.insight-card .insight-label {
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    opacity: 0.7;
}

.insight-card .insight-value {
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0.2rem 0;
}

.insight-card .insight-sub {
    font-size: 0.9rem;
    color: #cbd5e1;
    margin: 0;
}

.insight-card.success { background: linear-gradient(135deg, #0ea5e9, #22d3ee); color: #0b1224; }
.insight-card.warning { background: linear-gradient(135deg, #f97316, #facc15); color: #1f1f1f; }
.insight-card.info { background: linear-gradient(135deg, #312e81, #4c1d95); }
.insight-card.alert { background: linear-gradient(135deg, #be123c, #f97316); }

.card-clickable {
    cursor: pointer;
    transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.card-clickable:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
}

.overview-item {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.25rem;
    background: #f7fafc;
    border-radius: 12px;
    transition: all 0.3s ease;
}

.overview-item:hover {
    background: #edf2f7;
    transform: translateY(-2px);
}

.overview-icon {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
}

.overview-icon.blue {
    background: linear-gradient(135deg, #4facfe, #00f2fe);
}

.overview-icon.orange {
    background: linear-gradient(135deg, #fa709a, #fee140);
}

.overview-icon.green {
    background: linear-gradient(135deg, #43e97b, #38f9d7);
}

.overview-icon.purple {
    background: linear-gradient(135deg, #a8edea, #fed6e3);
}

.overview-item h4 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1a202c;
    margin: 0 0 0.25rem 0;
}

.overview-item p {
    color: #718096;
    font-size: 0.85rem;
    margin: 0;
}

/* Table Styles - Clean & Minimal */
.super-table-container {
    overflow-x: auto;
}

.super-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: auto;
    /* Changed from fixed to auto for better spacing */
}

.super-table thead {
    background: #f8fafc;
    border-bottom: 2px solid #e2e8f0;
}

.super-table th {
    padding: 1rem;
    /* Reduced from 1rem 1.5rem for tighter spacing */
    text-align: left;
    font-weight: 600;
    font-size: 0.875rem;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
    /* Prevent header text wrapping */
}

/* Removed fixed column widths - columns will auto-size based on content */

.super-table tbody tr {
    border-bottom: 1px solid #e2e8f0;
    transition: background-color 0.15s ease;
}

.super-table tbody tr:hover {
    background-color: #f8fafc;
}

.super-table td {
    padding: 0.875rem 1rem;
    /* Reduced from 1rem 1.5rem for tighter spacing */
    color: #334155;
    font-size: 0.9375rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.admin-name {
    font-weight: 600;
    color: #0f172a;
}

.admin-email {
    color: #64748b;
}

.admin-phone {
    color: #94a3b8;
}

.admin-date {
    color: #94a3b8;
    font-size: 0.875rem;
}

.loans-count {
    font-weight: 600;
    color: #667eea;
}

/* Role Badge - Minimal */
.role-badge {
    padding: 0.375rem 0.75rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: inline-block;
}

.role-badge.super-admin {
    background: #fce7f3;
    color: #be123c;
    border: 1px solid #fbcfe8;
}

.role-badge.admin {
    background: #dbeafe;
    color: #1e40af;
    border: 1px solid #bfdbfe;
}

/* Status Badge - Minimal */
.status-badge {
    padding: 0.375rem 0.75rem;
    border-radius: 4px;
    font-size: 0.8125rem;
    font-weight: 600;
    display: inline-block;
}

.status-badge.status-success {
    background: #dcfce7;
    color: #166534;
    border: 1px solid #bbf7d0;
}

.status-badge.status-warning {
    background: #fef3c7;
    color: #92400e;
    border: 1px solid #fde68a;
}

.status-badge.status-danger {
    background: #fee2e2;
    color: #991b1b;
    border: 1px solid #fecaca;
}

/* Action Buttons - Clean & Minimal */
.action-buttons {
    display: flex;
    gap: 0.5rem;
}

.action-btn {
    padding: 0.5rem 0.875rem;
    border-radius: 4px;
    border: 1px solid;
    cursor: pointer;
    transition: all 0.15s ease;
    font-size: 0.8125rem;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    background: white;
}

.action-btn.view {
    color: #0369a1;
    border-color: #bae6fd;
}

.action-btn.view:hover {
    background: #f0f9ff;
    border-color: #7dd3fc;
}

.action-btn.login {
    color: #7c3aed;
    border-color: #ddd6fe;
}

.action-btn.login:hover {
    background: #faf5ff;
    border-color: #c4b5fd;
}

.action-btn.edit {
    color: #059669;
    border-color: #a7f3d0;
}

.action-btn.edit:hover {
    background: #f0fdf4;
    border-color: #6ee7b7;
}

.action-btn.delete {
    color: #dc2626;
    border-color: #fecaca;
}

.action-btn.delete:hover {
    background: #fef2f2;
    border-color: #fca5a5;
}

/* System Logs */
.logs-container {
    padding: 1.5rem;
    max-height: 600px;
    overflow-y: auto;
}

.log-item {
    display: flex;
    gap: 1rem;
    padding: 1.25rem;
    border-radius: 12px;
    margin-bottom: 1rem;
    border-left: 4px solid;
    transition: all 0.3s ease;
}

.log-item:hover {
    transform: translateX(5px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.log-item.log-success {
    background: #f0fdf4;
    border-left-color: #22c55e;
}

/* Premium Dashboard Re-creation */
.dashboard-summary-premium {
    animation: fadeIn 0.8s ease-out;
}

.live-status-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    padding: 1rem 1.5rem;
    background: rgba(255, 255, 255, 0.05);
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.live-indicator {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.pulse-dot {
    width: 10px;
    height: 10px;
    background: #48bb78;
    border-radius: 50%;
    box-shadow: 0 0 0 rgba(72, 187, 120, 0.4);
    animation: pulse-green 2s infinite;
}

.live-text {
    font-weight: 600;
    color: #2d3748;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.last-updated {
    font-size: 0.85rem;
    color: #718096;
}

/* Glassmorphism Stat Cards */
.super-stats-grid-premium {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    grid-gap: 1.5rem;
    gap: 1.5rem;
    margin-bottom: 2.5rem;
}

.glass-morph {
    background: rgba(255, 255, 255, 0.8);
    -webkit-backdrop-filter: blur(20px);
            backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.07);
}

.premium-stat-card {
    padding: 1.75rem;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.premium-stat-card:hover {
    transform: translateY(-8px);
}

.stat-icon-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
}

.purple .stat-icon-wrapper {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.pink .stat-icon-wrapper {
    background: linear-gradient(135deg, #ff758c 0%, #ff7eb3 100%);
}

.blue .stat-icon-wrapper {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.green .stat-icon-wrapper {
    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.stat-label {
    font-size: 0.9rem;
    color: #718096;
    margin: 0;
}

.stat-value {
    font-size: 2rem;
    font-weight: 800;
    color: #1a202c;
    margin: 0.25rem 0;
}

.stat-trend {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.85rem;
    font-weight: 600;
}

.stat-trend.positive {
    color: #48bb78;
}

.stat-trend.negative {
    color: #f56565;
}

.stat-trend.neutral {
    color: #718096;
}

/* Bento Grid Widgets */
.dashboard-widgets-grid-premium {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: 2rem;
    gap: 2rem;
    margin-bottom: 2rem;
}

.widget-card {
    padding: 2rem;
    border-radius: 24px;
}

.widget-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
}

.widget-header h2 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #2d3748;
    margin: 0;
}

/* Premium Chart */
.premium-chart-container {
    display: flex;
    gap: 1.5rem;
    height: 300px;
    position: relative;
    padding-left: 3rem;
}

.chart-y-axis {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 0.75rem;
    color: #a0aec0;
}

.chart-bars-wrapper {
    flex: 1 1;
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    gap: 1rem;
    border-bottom: 1px solid #edf2f7;
}

.chart-bar-group {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
}

.bar-interactive {
    width: 60%;
    max-width: 40px;
    background: linear-gradient(to top, #667eea, #764ba2);
    border-radius: 6px 6px 0 0;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;
}

.bar-interactive:hover {
    filter: brightness(1.2);
    box-shadow: 0 4px 15px rgba(118, 75, 162, 0.4);
}

.bar-tooltip {
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%) translateY(10px);
    background: #1a202c;
    color: white;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    font-size: 0.75rem;
    opacity: 0;
    pointer-events: none;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.bar-interactive:hover .bar-tooltip {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
}

.bar-label {
    font-size: 0.8rem;
    color: #718096;
}

/* Health Monitor */
.health-metrics-list {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.health-metric-item {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.metric-info {
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
    font-weight: 600;
}

.metric-status {
    font-size: 0.75rem;
    padding: 0.25rem 0.6rem;
    border-radius: 20px;
}

.metric-status.online {
    background: #c6f6d5;
    color: #22543d;
}

.metric-status.busy {
    background: #feebc8;
    color: #744210;
}

.metric-progress-base {
    height: 8px;
    background: #edf2f7;
    border-radius: 4px;
    overflow: hidden;
}

.metric-progress-fill {
    height: 100%;
    background: #48bb78;
    border-radius: 4px;
    transition: width 1s cubic-bezier(0.4, 0, 0.2, 1);
}

.metric-progress-fill.blue {
    background: #4299e1;
}

.metric-progress-fill.warning {
    background: #ed8936;
}

.premium-full-audit-btn {
    margin-top: 2rem;
    width: 100%;
    padding: 1rem;
    background: #1a202c;
    color: white;
    border: none;
    border-radius: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.premium-full-audit-btn:hover {
    background: #2d3748;
    transform: scale(1.02);
}

/* Premium Activity List */
.recent-activity-premium {
    padding: 2rem;
    border-radius: 24px;
}

.premium-activity-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.premium-activity-item {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    grid-gap: 1.5rem;
    gap: 1.5rem;
    padding: 1.25rem;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.4);
    transition: background 0.2s ease;
}

.premium-activity-item:hover {
    background: rgba(255, 255, 255, 0.8);
}

.activity-status-icon {
    width: 12px;
    height: 12px;
    border-radius: 50%;
}

.success .activity-status-icon {
    background: #48bb78;
    box-shadow: 0 0 10px rgba(72, 187, 120, 0.4);
}

.warning .activity-status-icon {
    background: #ed8936;
    box-shadow: 0 0 10px rgba(237, 137, 54, 0.4);
}

.error .activity-status-icon {
    background: #f56565;
    box-shadow: 0 0 10px rgba(245, 101, 101, 0.4);
}

.info .activity-status-icon {
    background: #4299e1;
    box-shadow: 0 0 10px rgba(66, 153, 225, 0.4);
}

.activity-main {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 0.25rem;
}

.activity-user {
    font-size: 0.75rem;
    color: #718096;
}

.activity-desc {
    margin: 0;
    font-size: 0.9rem;
    color: #4a5568;
}

.activity-time {
    font-size: 0.8rem;
    color: #a0aec0;
}

/* Animations */
@keyframes pulse-green {
    0% {
        box-shadow: 0 0 0 0 rgba(72, 187, 120, 0.7);
    }

    70% {
        box-shadow: 0 0 0 10px rgba(72, 187, 120, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(72, 187, 120, 0);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Mobile Responsive Adjustments */
@media (max-width: 1024px) {
    .dashboard-widgets-grid-premium {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .super-stats-grid-premium {
        grid-template-columns: 1fr;
    }

    .live-status-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
    }
}

.log-item.log-warning {
    background: #fef3c7;
    border-left-color: #f59e0b;
}

.log-item.log-error {
    background: #fee2e2;
    border-left-color: #ef4444;
}

.log-item.log-info {
    background: #dbeafe;
    border-left-color: #3b82f6;
}

.log-icon {
    font-size: 1.5rem;
    flex-shrink: 0;
}

.log-content {
    flex: 1 1;
}

.log-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
}

.log-header h4 {
    margin: 0;
    font-size: 1rem;
    color: #1a202c;
    font-weight: 700;
}

.log-time {
    font-size: 0.85rem;
    color: #718096;
}

.log-details {
    margin: 0 0 0.5rem 0;
    color: #4a5568;
    font-size: 0.9rem;
    line-height: 1.5;
}

.log-user {
    font-size: 0.85rem;
    color: #718096;
    font-weight: 500;
}

/* Responsive */
@media (max-width: 1200px) {
    .super-stats-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .super-admin-welcome-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }

    .super-quick-actions {
        width: 100%;
        flex-wrap: wrap;
    }

    .super-action-btn {
        flex: 1 1;
        min-width: calc(50% - 0.375rem);
    }

    .super-stats-grid {
        grid-template-columns: 1fr;
    }



    .overview-grid {
        grid-template-columns: 1fr;
    }

    .super-table th,
    .super-table td {
        padding: 0.875rem;
        font-size: 0.85rem;
    }

    .action-buttons {
        flex-direction: column;
    }
}

@media (max-width: 480px) {
    .super-admin-welcome-header h1 {
        font-size: 1.5rem;
    }

    .super-admin-subtitle {
        font-size: 0.9rem;
    }

    .super-card-header {
        flex-direction: column;
        gap: 1rem;
        align-items: flex-start;
    }

    .add-btn,
    .export-btn {
        width: 100%;
    }

    .super-table {
        font-size: 0.8rem;
    }
}

/* Dashboard Widgets */
.dashboard-widgets-grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: 1.5rem;
    gap: 1.5rem;
    margin-top: 2rem;
}

.performance-chart-placeholder {
    height: 200px;
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    padding: 1.5rem;
    background: #fdfdfd;
}

.placeholder-bar {
    width: 30px;
    background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
    border-radius: 4px 4px 0 0;
    animation: barGrow 1s ease-out;
}

@keyframes barGrow {
    from {
        height: 0;
    }
}

.performance-labels {
    display: flex;
    justify-content: space-around;
    padding: 0 1.5rem 1rem;
    color: #a0aec0;
    font-size: 0.8rem;
}

.mini-logs {
    padding: 1rem;
}

.mini-log-item {
    display: flex;
    gap: 1rem;
    padding: 0.75rem 0;
    border-bottom: 1px solid #f1f5f9;
}

.mini-log-item:last-child {
    border-bottom: none;
}

.log-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #667eea;
    margin-top: 5px;
    flex-shrink: 0;
}

.mini-log-info p {
    margin: 0;
    font-size: 0.875rem;
    color: #2d3748;
}

.mini-log-info small {
    color: #a0aec0;
}

@media (max-width: 1024px) {
    .dashboard-widgets-grid {
        grid-template-columns: 1fr;
    }
}

/* System Modal Styles */
.system-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.7);
    -webkit-backdrop-filter: blur(8px);
            backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.2s ease;
}

.system-modal-content.bento-look {
    background: white;
    width: 90%;
    max-width: 450px;
    border-radius: 20px;
    padding: 0;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    overflow: hidden;
    animation: slideUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.system-modal-header {
    padding: 1.5rem;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.system-modal-header h3 {
    margin: 0;
    color: #1e293b;
    font-size: 1.25rem;
    font-weight: 700;
}

.close-x {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #64748b;
    cursor: pointer;
    line-height: 1;
}

.system-modal-body {
    padding: 2rem 1.5rem;
    text-align: center;
}

.system-modal-body p {
    margin: 0;
    color: #475569;
    font-size: 1.1rem;
    line-height: 1.6;
}

.system-modal-footer {
    padding: 1.25rem 1.5rem;
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
    display: flex;
    gap: 1rem;
    justify-content: center;
}

.modal-btn-confirm,
.modal-btn-cancel {
    padding: 0.75rem 1.75rem;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 0.95rem;
}

.modal-btn-confirm {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    min-width: 120px;
}

.modal-btn-confirm:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.modal-btn-cancel {
    background: white;
    border: 1px solid #e2e8f0;
    color: #64748b;
}

.modal-btn-cancel:hover {
    background: #f1f5f9;
    color: #1e293b;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}


.header-actions.search-row {
    margin-top: 0.75rem;
    display: flex;
    gap: 0.5rem;
    align-items: center;
}
.search-input {
    flex: 1 1;
    padding: 0.55rem 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    font-size: 0.95rem;
}


.user-header { align-items: center; gap: 0.5rem; }
.header-left { display: flex; flex-direction: column; gap: 4px; }
.header-sub { margin: 0; color: #6b7280; font-size: 0.9rem; }

/* Role Focus Panels */
.role-focus-panel {
    margin: 1rem 1.25rem 0 1.25rem;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 16px 18px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(0,0,0,0.04);
}
.role-focus-panel.sales { border-left: 4px solid #7c3aed; }
.role-focus-panel.branch { border-left: 4px solid #0ea5e9; }
.role-focus-panel.collection { border-left: 4px solid #f59e0b; }
.role-panel-head { display: flex; justify-content: space-between; align-items: center; gap: 1rem; flex-wrap: wrap; }
.role-panel-head h3 { margin: 0; color: #0f172a; }
.eyebrow { margin: 0; text-transform: uppercase; letter-spacing: 0.6px; font-weight: 700; color: #94a3b8; font-size: 12px; }
.role-actions { display: flex; gap: 8px; flex-wrap: wrap; }
.role-kpi-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); grid-gap: 10px; gap: 10px; margin-top: 12px; }
.role-kpi { border: 1px solid #e2e8f0; border-radius: 10px; padding: 12px; background: #f8fafc; }
.role-kpi span { display: block; color: #64748b; font-size: 12px; margin-bottom: 6px; }
.role-kpi strong { color: #0f172a; font-size: 22px; }
.role-pills { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }
.pill-stat { padding: 8px 10px; border-radius: 999px; background: #e2e8f0; color: #0f172a; font-weight: 700; font-size: 12px; }
.pill-stat.warn { background: #fff7ed; color: #c2410c; }
.pill-stat.info { background: #ecfeff; color: #0ea5e9; }
.pill-stat.muted { background: #f1f5f9; color: #475569; }
`, "",{"version":3,"sources":["webpack://./src/pages/SuperAdminDashboardPage.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,6DAA6D;IAC7D,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,2DAA2D;IAC3D,gBAAW;IAAX,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,0CAA0C;IAC1C,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;;;AAIA,gBAAgB;AAChB;IACI,2BAA2B;AAC/B;;AAEA,eAAe;AACf;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;;IAEI,yBAAyB;IACzB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;;IAEI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,gBAAW;IAAX,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAS;IAAT,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,qDAAqD;IACrD,2CAA2C;IAC3C,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,8CAA8C;AAClD;;AAEA,eAAe,kBAAkB,EAAE,sBAAsB,EAAE,YAAY,EAAE;AACzE,eAAe,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACvE,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,cAAc,EAAE;AACvC,aAAa,kBAAkB,EAAE,cAAc,EAAE,sBAAsB,EAAE;;AAEzE;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,YAAY;AAChB;AACA;IACI,SAAO;IACP,qCAAqC;IACrC,0BAA0B;IAC1B,kDAAkD;AACtD;AACA,sBAAsB,iCAAiC,EAAE;AACzD,yBAAyB,iCAAiC,EAAE;AAC5D,yBAAyB,iCAAiC,EAAE;AAC5D,4BAA4B,mBAAmB,EAAE;;AAEjD;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAS;IAAT,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,8CAA8C;IAC9C,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,SAAS;AACb;;AAEA,wBAAwB,qDAAqD,EAAE,cAAc,EAAE;AAC/F,wBAAwB,qDAAqD,EAAE,cAAc,EAAE;AAC/F,qBAAqB,qDAAqD,EAAE;AAC5E,sBAAsB,qDAAqD,EAAE;;AAE7E;IACI,eAAe;IACf,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;AACb;;AAEA,mCAAmC;AACnC;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,iDAAiD;IACjD,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA,0EAA0E;;AAE1E;IACI,gCAAgC;IAChC,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,iDAAiD;IACjD,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,0BAA0B;IAC1B,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA,kCAAkC;AAClC;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,qCAAqC;IACrC,mCAA2B;YAA3B,2BAA2B;IAC3B,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,2DAA2D;IAC3D,gBAAW;IAAX,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,mCAA2B;YAA3B,2BAA2B;IAC3B,0CAA0C;IAC1C,gDAAgD;AACpD;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,4DAA4D;AAChE;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAS;IAAT,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,qBAAqB;IACrB,6BAA6B;IAC7B,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,eAAe;IACf,qDAAqD;IACrD,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,4CAA4C;IAC5C,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,gBAAW;IAAX,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,2CAA2C;IAC/C;;IAEA;QACI,4CAA4C;IAChD;;IAEA;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,kCAAkC;AAClC;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,WAAW;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,SAAO;QACP,+BAA+B;IACnC;;IAEA;QACI,0BAA0B;IAC9B;;;;IAIA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,uBAAuB;IAC3B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAW;IAAX,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,6DAA6D;IAC7D,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,sBAAsB;IACtB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,kCAA0B;YAA1B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,iDAAiD;IACjD,gBAAgB;IAChB,yDAAyD;AAC7D;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;;IAEI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;;AAGA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,SAAO;IACP,wBAAwB;IACxB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA,eAAe,mBAAmB,EAAE,WAAW,EAAE;AACjD,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAChE,cAAc,SAAS,EAAE,cAAc,EAAE,iBAAiB,EAAE;;AAE5D,sBAAsB;AACtB;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;AAC3C;AACA,0BAA0B,8BAA8B,EAAE;AAC1D,2BAA2B,8BAA8B,EAAE;AAC3D,+BAA+B,8BAA8B,EAAE;AAC/D,mBAAmB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AACnH,sBAAsB,SAAS,EAAE,cAAc,EAAE;AACjD,WAAW,SAAS,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC3H,gBAAgB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC1D,iBAAiB,aAAa,EAAE,2DAA2D,EAAE,cAAS,EAAT,SAAS,EAAE,gBAAgB,EAAE;AAC1H,YAAY,yBAAyB,EAAE,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAChG,iBAAiB,cAAc,EAAE,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACtF,mBAAmB,cAAc,EAAE,eAAe,EAAE;AACpD,cAAc,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAC1E,aAAa,iBAAiB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC9H,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE","sourcesContent":["/* Super Admin Dashboard Styles */\n\n.super-admin-dashboard-page {\n    animation: fadeIn 0.5s ease;\n    background: #f8fafc;\n    width: 100%;\n}\n\n/* Super Admin Header */\n.super-admin-welcome-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n    padding: 1.5rem;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    border-radius: 16px;\n    color: white;\n}\n\n.super-admin-welcome-header h1 {\n    font-size: 2rem;\n    font-weight: 700;\n    margin: 0 0 0.5rem 0;\n}\n\n.super-admin-subtitle {\n    opacity: 0.95;\n    font-size: 1rem;\n    margin: 0;\n}\n\n/* Super Quick Actions */\n.super-quick-actions {\n    display: flex;\n    gap: 0.75rem;\n}\n\n.super-action-btn {\n    padding: 0.75rem 1.25rem;\n    border-radius: 10px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    border: none;\n    font-size: 0.9rem;\n    color: white;\n}\n\n.super-action-btn.create-admin {\n    background: rgba(255, 255, 255, 0.2);\n    border: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n.super-action-btn.create-user {\n    background: rgba(255, 255, 255, 0.15);\n    border: 2px solid rgba(255, 255, 255, 0.25);\n}\n\n.super-action-btn.settings {\n    background: rgba(255, 255, 255, 0.1);\n    border: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.super-action-btn:hover {\n    background: rgba(255, 255, 255, 0.3);\n    transform: translateY(-2px);\n}\n\n/* Enhanced Stats Grid */\n.super-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n    gap: 1.5rem;\n    margin-bottom: 2rem;\n}\n\n.super-stat-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    display: flex;\n    gap: 1.25rem;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n}\n\n.super-stat-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 4px;\n    height: 100%;\n}\n\n.super-stat-card.purple::before {\n    background: linear-gradient(135deg, #9f7aea, #805ad5);\n}\n\n.super-stat-card.pink::before {\n    background: linear-gradient(135deg, #f093fb, #f5576c);\n}\n\n.super-stat-card.blue::before {\n    background: linear-gradient(135deg, #4facfe, #00f2fe);\n}\n\n.super-stat-card.green::before {\n    background: linear-gradient(135deg, #43e97b, #38f9d7);\n}\n\n.super-stat-card:hover {\n    transform: translateY(-8px);\n    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);\n}\n\n.super-stat-card.purple .stat-icon {\n    background: linear-gradient(135deg, #9f7aea, #805ad5);\n}\n\n.super-stat-card.pink .stat-icon {\n    background: linear-gradient(135deg, #f093fb, #f5576c);\n}\n\n.super-stat-card.blue .stat-icon {\n    background: linear-gradient(135deg, #4facfe, #00f2fe);\n}\n\n.super-stat-card.green .stat-icon {\n    background: linear-gradient(135deg, #43e97b, #38f9d7);\n}\n\n\n\n/* Tab Content */\n.super-tab-content {\n    animation: fadeIn 0.3s ease;\n}\n\n/* Super Card */\n.super-card {\n    background: white;\n    border-radius: 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    overflow: hidden;\n}\n\n.super-card-header {\n    padding: 1.5rem;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.users-card-header {\n    gap: 1rem;\n}\n\n.users-card-title {\n    display: flex;\n    flex-direction: column;\n}\n\n.users-title {\n    font-size: 1rem;\n    margin: 0;\n    color: #2d3748;\n    font-weight: 700;\n}\n\n.users-note {\n    margin: 4px 0 0 0;\n    color: #718096;\n    font-size: 0.85rem;\n}\n\n.users-header-actions {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.include-admins-toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.9rem;\n    color: #4a5568;\n}\n\n.include-admins-toggle input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n}\n\n.user-status-select,\n.user-kyc-select {\n    padding: 6px 8px;\n    border-radius: 6px;\n    border: 1px solid #e2e8f0;\n    background: white;\n    font-size: 0.95rem;\n}\n\n.user-status-select {\n    min-width: 120px;\n}\n\n.user-kyc-select {\n    min-width: 140px;\n}\n\n.super-card-header h2 {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #1a202c;\n    margin: 0;\n}\n\n.add-btn,\n.export-btn {\n    padding: 0.625rem 1.25rem;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-size: 0.9rem;\n}\n\n.add-btn:hover,\n.export-btn:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n/* Header Actions */\n.header-actions {\n    display: flex;\n    gap: 0.75rem;\n    align-items: center;\n}\n\n.action-header-btn {\n    padding: 0.625rem 1rem;\n    border: 1px solid #e2e8f0;\n    background: white;\n    color: #475569;\n    border-radius: 6px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-size: 0.875rem;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.action-header-btn:hover {\n    background: #f8fafc;\n    border-color: #cbd5e0;\n    transform: translateY(-1px);\n}\n\n.action-header-btn.create-admin:hover {\n    background: #ede9fe;\n    border-color: #a78bfa;\n    color: #7c3aed;\n}\n\n.action-header-btn.create-user:hover {\n    background: #dbeafe;\n    border-color: #60a5fa;\n    color: #2563eb;\n}\n\n.action-header-btn.settings:hover {\n    background: #fef3c7;\n    border-color: #fbbf24;\n    color: #d97706;\n}\n\n/* Overview Grid */\n.overview-content {\n    margin-bottom: 2rem;\n}\n\n.overview-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 1.5rem;\n    padding: 1.5rem;\n}\n\n.enhanced-overview-grid {\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 1rem;\n    padding: 1.25rem;\n}\n\n.overview-actions {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.insight-pulse-row {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 1rem;\n    padding: 0 1.25rem 0.75rem;\n}\n\n.pulse-card {\n    background: linear-gradient(135deg, #0f172a, #1f2a44);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    color: #e2e8f0;\n    border-radius: 14px;\n    padding: 1rem;\n    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.22);\n}\n\n.pulse-label { font-size: 0.85rem; letter-spacing: 0.02em; opacity: 0.8; }\n.pulse-value { font-size: 1.8rem; font-weight: 800; margin: 0.15rem 0; }\n.pulse-value.warning { color: #f59e0b; }\n.pulse-value.success { color: #22c55e; }\n.pulse-sub { font-size: 0.85rem; color: #cbd5e1; margin-bottom: 0.35rem; }\n\n.sparkbar {\n    display: flex;\n    align-items: flex-end;\n    gap: 4px;\n    height: 50px;\n}\n.sparkbar span {\n    flex: 1;\n    background: rgba(255, 255, 255, 0.14);\n    border-radius: 4px 4px 0 0;\n    transition: height 0.3s ease, background 0.3s ease;\n}\n.sparkbar.info span { background: rgba(59,130,246,0.28); }\n.sparkbar.warning span { background: rgba(245,158,11,0.28); }\n.sparkbar.success span { background: rgba(16,185,129,0.28); }\n.sparkbar span:last-child { background: #7c3aed; }\n\n.overview-insights {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 1rem;\n    padding: 0 1.25rem 1.25rem;\n}\n\n.insight-card {\n    background: #0f172a;\n    color: #e2e8f0;\n    border-radius: 12px;\n    padding: 1rem 1.25rem;\n    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.25);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.insight-card .insight-label {\n    font-size: 0.85rem;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    opacity: 0.7;\n}\n\n.insight-card .insight-value {\n    font-size: 1.8rem;\n    font-weight: 700;\n    margin: 0.2rem 0;\n}\n\n.insight-card .insight-sub {\n    font-size: 0.9rem;\n    color: #cbd5e1;\n    margin: 0;\n}\n\n.insight-card.success { background: linear-gradient(135deg, #0ea5e9, #22d3ee); color: #0b1224; }\n.insight-card.warning { background: linear-gradient(135deg, #f97316, #facc15); color: #1f1f1f; }\n.insight-card.info { background: linear-gradient(135deg, #312e81, #4c1d95); }\n.insight-card.alert { background: linear-gradient(135deg, #be123c, #f97316); }\n\n.card-clickable {\n    cursor: pointer;\n    transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.card-clickable:hover {\n    transform: translateY(-6px);\n    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);\n}\n\n.overview-item {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding: 1.25rem;\n    background: #f7fafc;\n    border-radius: 12px;\n    transition: all 0.3s ease;\n}\n\n.overview-item:hover {\n    background: #edf2f7;\n    transform: translateY(-2px);\n}\n\n.overview-icon {\n    width: 56px;\n    height: 56px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.5rem;\n}\n\n.overview-icon.blue {\n    background: linear-gradient(135deg, #4facfe, #00f2fe);\n}\n\n.overview-icon.orange {\n    background: linear-gradient(135deg, #fa709a, #fee140);\n}\n\n.overview-icon.green {\n    background: linear-gradient(135deg, #43e97b, #38f9d7);\n}\n\n.overview-icon.purple {\n    background: linear-gradient(135deg, #a8edea, #fed6e3);\n}\n\n.overview-item h4 {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #1a202c;\n    margin: 0 0 0.25rem 0;\n}\n\n.overview-item p {\n    color: #718096;\n    font-size: 0.85rem;\n    margin: 0;\n}\n\n/* Table Styles - Clean & Minimal */\n.super-table-container {\n    overflow-x: auto;\n}\n\n.super-table {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: auto;\n    /* Changed from fixed to auto for better spacing */\n}\n\n.super-table thead {\n    background: #f8fafc;\n    border-bottom: 2px solid #e2e8f0;\n}\n\n.super-table th {\n    padding: 1rem;\n    /* Reduced from 1rem 1.5rem for tighter spacing */\n    text-align: left;\n    font-weight: 600;\n    font-size: 0.875rem;\n    color: #475569;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    white-space: nowrap;\n    /* Prevent header text wrapping */\n}\n\n/* Removed fixed column widths - columns will auto-size based on content */\n\n.super-table tbody tr {\n    border-bottom: 1px solid #e2e8f0;\n    transition: background-color 0.15s ease;\n}\n\n.super-table tbody tr:hover {\n    background-color: #f8fafc;\n}\n\n.super-table td {\n    padding: 0.875rem 1rem;\n    /* Reduced from 1rem 1.5rem for tighter spacing */\n    color: #334155;\n    font-size: 0.9375rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.admin-name {\n    font-weight: 600;\n    color: #0f172a;\n}\n\n.admin-email {\n    color: #64748b;\n}\n\n.admin-phone {\n    color: #94a3b8;\n}\n\n.admin-date {\n    color: #94a3b8;\n    font-size: 0.875rem;\n}\n\n.loans-count {\n    font-weight: 600;\n    color: #667eea;\n}\n\n/* Role Badge - Minimal */\n.role-badge {\n    padding: 0.375rem 0.75rem;\n    border-radius: 4px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    display: inline-block;\n}\n\n.role-badge.super-admin {\n    background: #fce7f3;\n    color: #be123c;\n    border: 1px solid #fbcfe8;\n}\n\n.role-badge.admin {\n    background: #dbeafe;\n    color: #1e40af;\n    border: 1px solid #bfdbfe;\n}\n\n/* Status Badge - Minimal */\n.status-badge {\n    padding: 0.375rem 0.75rem;\n    border-radius: 4px;\n    font-size: 0.8125rem;\n    font-weight: 600;\n    display: inline-block;\n}\n\n.status-badge.status-success {\n    background: #dcfce7;\n    color: #166534;\n    border: 1px solid #bbf7d0;\n}\n\n.status-badge.status-warning {\n    background: #fef3c7;\n    color: #92400e;\n    border: 1px solid #fde68a;\n}\n\n.status-badge.status-danger {\n    background: #fee2e2;\n    color: #991b1b;\n    border: 1px solid #fecaca;\n}\n\n/* Action Buttons - Clean & Minimal */\n.action-buttons {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.action-btn {\n    padding: 0.5rem 0.875rem;\n    border-radius: 4px;\n    border: 1px solid;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    font-size: 0.8125rem;\n    font-weight: 500;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.375rem;\n    background: white;\n}\n\n.action-btn.view {\n    color: #0369a1;\n    border-color: #bae6fd;\n}\n\n.action-btn.view:hover {\n    background: #f0f9ff;\n    border-color: #7dd3fc;\n}\n\n.action-btn.login {\n    color: #7c3aed;\n    border-color: #ddd6fe;\n}\n\n.action-btn.login:hover {\n    background: #faf5ff;\n    border-color: #c4b5fd;\n}\n\n.action-btn.edit {\n    color: #059669;\n    border-color: #a7f3d0;\n}\n\n.action-btn.edit:hover {\n    background: #f0fdf4;\n    border-color: #6ee7b7;\n}\n\n.action-btn.delete {\n    color: #dc2626;\n    border-color: #fecaca;\n}\n\n.action-btn.delete:hover {\n    background: #fef2f2;\n    border-color: #fca5a5;\n}\n\n/* System Logs */\n.logs-container {\n    padding: 1.5rem;\n    max-height: 600px;\n    overflow-y: auto;\n}\n\n.log-item {\n    display: flex;\n    gap: 1rem;\n    padding: 1.25rem;\n    border-radius: 12px;\n    margin-bottom: 1rem;\n    border-left: 4px solid;\n    transition: all 0.3s ease;\n}\n\n.log-item:hover {\n    transform: translateX(5px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.log-item.log-success {\n    background: #f0fdf4;\n    border-left-color: #22c55e;\n}\n\n/* Premium Dashboard Re-creation */\n.dashboard-summary-premium {\n    animation: fadeIn 0.8s ease-out;\n}\n\n.live-status-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n    padding: 1rem 1.5rem;\n    background: rgba(255, 255, 255, 0.05);\n    backdrop-filter: blur(10px);\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.live-indicator {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.pulse-dot {\n    width: 10px;\n    height: 10px;\n    background: #48bb78;\n    border-radius: 50%;\n    box-shadow: 0 0 0 rgba(72, 187, 120, 0.4);\n    animation: pulse-green 2s infinite;\n}\n\n.live-text {\n    font-weight: 600;\n    color: #2d3748;\n    font-size: 0.9rem;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.last-updated {\n    font-size: 0.85rem;\n    color: #718096;\n}\n\n/* Glassmorphism Stat Cards */\n.super-stats-grid-premium {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n    gap: 1.5rem;\n    margin-bottom: 2.5rem;\n}\n\n.glass-morph {\n    background: rgba(255, 255, 255, 0.8);\n    backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.07);\n}\n\n.premium-stat-card {\n    padding: 1.75rem;\n    border-radius: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n    transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.premium-stat-card:hover {\n    transform: translateY(-8px);\n}\n\n.stat-icon-wrapper {\n    width: 48px;\n    height: 48px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n}\n\n.purple .stat-icon-wrapper {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.pink .stat-icon-wrapper {\n    background: linear-gradient(135deg, #ff758c 0%, #ff7eb3 100%);\n}\n\n.blue .stat-icon-wrapper {\n    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n}\n\n.green .stat-icon-wrapper {\n    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);\n}\n\n.stat-label {\n    font-size: 0.9rem;\n    color: #718096;\n    margin: 0;\n}\n\n.stat-value {\n    font-size: 2rem;\n    font-weight: 800;\n    color: #1a202c;\n    margin: 0.25rem 0;\n}\n\n.stat-trend {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.85rem;\n    font-weight: 600;\n}\n\n.stat-trend.positive {\n    color: #48bb78;\n}\n\n.stat-trend.negative {\n    color: #f56565;\n}\n\n.stat-trend.neutral {\n    color: #718096;\n}\n\n/* Bento Grid Widgets */\n.dashboard-widgets-grid-premium {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 2rem;\n    margin-bottom: 2rem;\n}\n\n.widget-card {\n    padding: 2rem;\n    border-radius: 24px;\n}\n\n.widget-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n}\n\n.widget-header h2 {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #2d3748;\n    margin: 0;\n}\n\n/* Premium Chart */\n.premium-chart-container {\n    display: flex;\n    gap: 1.5rem;\n    height: 300px;\n    position: relative;\n    padding-left: 3rem;\n}\n\n.chart-y-axis {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    font-size: 0.75rem;\n    color: #a0aec0;\n}\n\n.chart-bars-wrapper {\n    flex: 1;\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-around;\n    gap: 1rem;\n    border-bottom: 1px solid #edf2f7;\n}\n\n.chart-bar-group {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n}\n\n.bar-interactive {\n    width: 60%;\n    max-width: 40px;\n    background: linear-gradient(to top, #667eea, #764ba2);\n    border-radius: 6px 6px 0 0;\n    position: relative;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.bar-interactive:hover {\n    filter: brightness(1.2);\n    box-shadow: 0 4px 15px rgba(118, 75, 162, 0.4);\n}\n\n.bar-tooltip {\n    position: absolute;\n    top: -40px;\n    left: 50%;\n    transform: translateX(-50%) translateY(10px);\n    background: #1a202c;\n    color: white;\n    padding: 0.5rem 0.75rem;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    opacity: 0;\n    pointer-events: none;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.bar-interactive:hover .bar-tooltip {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n}\n\n.bar-label {\n    font-size: 0.8rem;\n    color: #718096;\n}\n\n/* Health Monitor */\n.health-metrics-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.health-metric-item {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.metric-info {\n    display: flex;\n    justify-content: space-between;\n    font-size: 0.9rem;\n    font-weight: 600;\n}\n\n.metric-status {\n    font-size: 0.75rem;\n    padding: 0.25rem 0.6rem;\n    border-radius: 20px;\n}\n\n.metric-status.online {\n    background: #c6f6d5;\n    color: #22543d;\n}\n\n.metric-status.busy {\n    background: #feebc8;\n    color: #744210;\n}\n\n.metric-progress-base {\n    height: 8px;\n    background: #edf2f7;\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.metric-progress-fill {\n    height: 100%;\n    background: #48bb78;\n    border-radius: 4px;\n    transition: width 1s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.metric-progress-fill.blue {\n    background: #4299e1;\n}\n\n.metric-progress-fill.warning {\n    background: #ed8936;\n}\n\n.premium-full-audit-btn {\n    margin-top: 2rem;\n    width: 100%;\n    padding: 1rem;\n    background: #1a202c;\n    color: white;\n    border: none;\n    border-radius: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.premium-full-audit-btn:hover {\n    background: #2d3748;\n    transform: scale(1.02);\n}\n\n/* Premium Activity List */\n.recent-activity-premium {\n    padding: 2rem;\n    border-radius: 24px;\n}\n\n.premium-activity-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.premium-activity-item {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    align-items: center;\n    gap: 1.5rem;\n    padding: 1.25rem;\n    border-radius: 16px;\n    background: rgba(255, 255, 255, 0.4);\n    transition: background 0.2s ease;\n}\n\n.premium-activity-item:hover {\n    background: rgba(255, 255, 255, 0.8);\n}\n\n.activity-status-icon {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n}\n\n.success .activity-status-icon {\n    background: #48bb78;\n    box-shadow: 0 0 10px rgba(72, 187, 120, 0.4);\n}\n\n.warning .activity-status-icon {\n    background: #ed8936;\n    box-shadow: 0 0 10px rgba(237, 137, 54, 0.4);\n}\n\n.error .activity-status-icon {\n    background: #f56565;\n    box-shadow: 0 0 10px rgba(245, 101, 101, 0.4);\n}\n\n.info .activity-status-icon {\n    background: #4299e1;\n    box-shadow: 0 0 10px rgba(66, 153, 225, 0.4);\n}\n\n.activity-main {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 0.25rem;\n}\n\n.activity-user {\n    font-size: 0.75rem;\n    color: #718096;\n}\n\n.activity-desc {\n    margin: 0;\n    font-size: 0.9rem;\n    color: #4a5568;\n}\n\n.activity-time {\n    font-size: 0.8rem;\n    color: #a0aec0;\n}\n\n/* Animations */\n@keyframes pulse-green {\n    0% {\n        box-shadow: 0 0 0 0 rgba(72, 187, 120, 0.7);\n    }\n\n    70% {\n        box-shadow: 0 0 0 10px rgba(72, 187, 120, 0);\n    }\n\n    100% {\n        box-shadow: 0 0 0 0 rgba(72, 187, 120, 0);\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Mobile Responsive Adjustments */\n@media (max-width: 1024px) {\n    .dashboard-widgets-grid-premium {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 768px) {\n    .super-stats-grid-premium {\n        grid-template-columns: 1fr;\n    }\n\n    .live-status-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0.5rem;\n    }\n}\n\n.log-item.log-warning {\n    background: #fef3c7;\n    border-left-color: #f59e0b;\n}\n\n.log-item.log-error {\n    background: #fee2e2;\n    border-left-color: #ef4444;\n}\n\n.log-item.log-info {\n    background: #dbeafe;\n    border-left-color: #3b82f6;\n}\n\n.log-icon {\n    font-size: 1.5rem;\n    flex-shrink: 0;\n}\n\n.log-content {\n    flex: 1;\n}\n\n.log-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0.5rem;\n}\n\n.log-header h4 {\n    margin: 0;\n    font-size: 1rem;\n    color: #1a202c;\n    font-weight: 700;\n}\n\n.log-time {\n    font-size: 0.85rem;\n    color: #718096;\n}\n\n.log-details {\n    margin: 0 0 0.5rem 0;\n    color: #4a5568;\n    font-size: 0.9rem;\n    line-height: 1.5;\n}\n\n.log-user {\n    font-size: 0.85rem;\n    color: #718096;\n    font-weight: 500;\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n    .super-stats-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .super-admin-welcome-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 1rem;\n    }\n\n    .super-quick-actions {\n        width: 100%;\n        flex-wrap: wrap;\n    }\n\n    .super-action-btn {\n        flex: 1;\n        min-width: calc(50% - 0.375rem);\n    }\n\n    .super-stats-grid {\n        grid-template-columns: 1fr;\n    }\n\n\n\n    .overview-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .super-table th,\n    .super-table td {\n        padding: 0.875rem;\n        font-size: 0.85rem;\n    }\n\n    .action-buttons {\n        flex-direction: column;\n    }\n}\n\n@media (max-width: 480px) {\n    .super-admin-welcome-header h1 {\n        font-size: 1.5rem;\n    }\n\n    .super-admin-subtitle {\n        font-size: 0.9rem;\n    }\n\n    .super-card-header {\n        flex-direction: column;\n        gap: 1rem;\n        align-items: flex-start;\n    }\n\n    .add-btn,\n    .export-btn {\n        width: 100%;\n    }\n\n    .super-table {\n        font-size: 0.8rem;\n    }\n}\n\n/* Dashboard Widgets */\n.dashboard-widgets-grid {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 1.5rem;\n    margin-top: 2rem;\n}\n\n.performance-chart-placeholder {\n    height: 200px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-around;\n    padding: 1.5rem;\n    background: #fdfdfd;\n}\n\n.placeholder-bar {\n    width: 30px;\n    background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);\n    border-radius: 4px 4px 0 0;\n    animation: barGrow 1s ease-out;\n}\n\n@keyframes barGrow {\n    from {\n        height: 0;\n    }\n}\n\n.performance-labels {\n    display: flex;\n    justify-content: space-around;\n    padding: 0 1.5rem 1rem;\n    color: #a0aec0;\n    font-size: 0.8rem;\n}\n\n.mini-logs {\n    padding: 1rem;\n}\n\n.mini-log-item {\n    display: flex;\n    gap: 1rem;\n    padding: 0.75rem 0;\n    border-bottom: 1px solid #f1f5f9;\n}\n\n.mini-log-item:last-child {\n    border-bottom: none;\n}\n\n.log-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #667eea;\n    margin-top: 5px;\n    flex-shrink: 0;\n}\n\n.mini-log-info p {\n    margin: 0;\n    font-size: 0.875rem;\n    color: #2d3748;\n}\n\n.mini-log-info small {\n    color: #a0aec0;\n}\n\n@media (max-width: 1024px) {\n    .dashboard-widgets-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* System Modal Styles */\n.system-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.7);\n    backdrop-filter: blur(8px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    animation: fadeIn 0.2s ease;\n}\n\n.system-modal-content.bento-look {\n    background: white;\n    width: 90%;\n    max-width: 450px;\n    border-radius: 20px;\n    padding: 0;\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n    overflow: hidden;\n    animation: slideUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.system-modal-header {\n    padding: 1.5rem;\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.system-modal-header h3 {\n    margin: 0;\n    color: #1e293b;\n    font-size: 1.25rem;\n    font-weight: 700;\n}\n\n.close-x {\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    color: #64748b;\n    cursor: pointer;\n    line-height: 1;\n}\n\n.system-modal-body {\n    padding: 2rem 1.5rem;\n    text-align: center;\n}\n\n.system-modal-body p {\n    margin: 0;\n    color: #475569;\n    font-size: 1.1rem;\n    line-height: 1.6;\n}\n\n.system-modal-footer {\n    padding: 1.25rem 1.5rem;\n    background: #f8fafc;\n    border-top: 1px solid #e2e8f0;\n    display: flex;\n    gap: 1rem;\n    justify-content: center;\n}\n\n.modal-btn-confirm,\n.modal-btn-cancel {\n    padding: 0.75rem 1.75rem;\n    border-radius: 10px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-size: 0.95rem;\n}\n\n.modal-btn-confirm {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border: none;\n    min-width: 120px;\n}\n\n.modal-btn-confirm:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.modal-btn-cancel {\n    background: white;\n    border: 1px solid #e2e8f0;\n    color: #64748b;\n}\n\n.modal-btn-cancel:hover {\n    background: #f1f5f9;\n    color: #1e293b;\n}\n\n@keyframes slideUp {\n    from {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n\n.header-actions.search-row {\n    margin-top: 0.75rem;\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n}\n.search-input {\n    flex: 1;\n    padding: 0.55rem 0.75rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    font-size: 0.95rem;\n}\n\n\n.user-header { align-items: center; gap: 0.5rem; }\n.header-left { display: flex; flex-direction: column; gap: 4px; }\n.header-sub { margin: 0; color: #6b7280; font-size: 0.9rem; }\n\n/* Role Focus Panels */\n.role-focus-panel {\n    margin: 1rem 1.25rem 0 1.25rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 14px;\n    padding: 16px 18px;\n    background: #fff;\n    box-shadow: 0 8px 20px rgba(0,0,0,0.04);\n}\n.role-focus-panel.sales { border-left: 4px solid #7c3aed; }\n.role-focus-panel.branch { border-left: 4px solid #0ea5e9; }\n.role-focus-panel.collection { border-left: 4px solid #f59e0b; }\n.role-panel-head { display: flex; justify-content: space-between; align-items: center; gap: 1rem; flex-wrap: wrap; }\n.role-panel-head h3 { margin: 0; color: #0f172a; }\n.eyebrow { margin: 0; text-transform: uppercase; letter-spacing: 0.6px; font-weight: 700; color: #94a3b8; font-size: 12px; }\n.role-actions { display: flex; gap: 8px; flex-wrap: wrap; }\n.role-kpi-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 10px; margin-top: 12px; }\n.role-kpi { border: 1px solid #e2e8f0; border-radius: 10px; padding: 12px; background: #f8fafc; }\n.role-kpi span { display: block; color: #64748b; font-size: 12px; margin-bottom: 6px; }\n.role-kpi strong { color: #0f172a; font-size: 22px; }\n.role-pills { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }\n.pill-stat { padding: 8px 10px; border-radius: 999px; background: #e2e8f0; color: #0f172a; font-weight: 700; font-size: 12px; }\n.pill-stat.warn { background: #fff7ed; color: #c2410c; }\n.pill-stat.info { background: #ecfeff; color: #0ea5e9; }\n.pill-stat.muted { background: #f1f5f9; color: #475569; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
